import { Skeleton } from '@/common/components/base/skeleton/Skeleton';
import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';
import WalletWrapperCard from '../walletCards/WalletWrapperCard';

export default function LoadingCreditList() {
  return (
    <Flex flexDirection={'column'} gap={12} width={'100%'}>
      {Array.from({ length: 2 }).map((_, i) => (
        <WalletWrapperCard
          key={i}
          wrapperProps={{
            width: '100%',
            padding: '12px',
            border: '1px solid {colors.gray-3}',
            bgColor: 'white',
          }}
        >
          <Flex flexDirection={'column'} gap={16}>
            <Flex
              height={32}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Skeleton width="110px" height="24px" borderRadius="8px" />
              <Skeleton width="80px" height="24px" borderRadius="8px" />
            </Flex>
            <Flex alignItems={'center'} gap={8}>
              <Typography color={'black-2'}>تاریخ واریز:</Typography>
              <Skeleton width="80px" height="24px" borderRadius="8px" />
            </Flex>
          </Flex>
        </WalletWrapperCard>
      ))}
    </Flex>
  );
}
